import * as React from 'react';
export var PillContext = /*#__PURE__*/React.createContext({
  pillBehavior: null
});
export var PillsContextProvider = PillContext.Provider;
export var usePillContext = function usePillContext() {
  return React.useContext(PillContext);
};
//# sourceMappingURL=pillContext.js.map
